import SnackBar from "./SnackBar";
export default SnackBar;
